import { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import USDRequestWithheldTable from '../../components/Table/TableBody/USDRequestWithheldTable';
import { Loader } from '@piggytechng/component-library';
import useUSDRequest from '../../hooks/useUSDRequest';
import ModalSearch from '../../components/Modals/ModalSearch';
import ModalFilter from '../../components/Modals/ModalFilter';
import NoData from '../../components/NoData/NoData';
import useRolePermissions from '../../hooks/useRolePermissions';
import WarningIcon from '../../assets/icons/Info.svg';
import ReceiptIcon from '../../assets/icons/pos-reciept.svg';
import CheckListIcon from '../../assets/icons/check-list.svg';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const USDWithHeldRequest = () => {
  const {
    fetchUSDRequests,
    isLoading,
    isLoadingMore,
    isLoadingMetrics,
    usdRequestsData,
    canResetSearch,
    canResetFilter,
    setUsdRequestsParams,
    usdRequestsParams,
    isTest,
  } = useUSDRequest('held');
  const [filterModal, setFilterModal] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  const { isLoadingRolesAndPermissions, restrictTabViewByRole } = useRolePermissions({});
  const usdRequestsMetricsData = useSelector((state: RootState) => state.usdRequestsMetrics);

  useEffect(() => {
    fetchUSDRequests();
  }, []);

  useEffect(() => {
    if (isLoadingRolesAndPermissions) return;
    restrictTabViewByRole('usdRequest', 'view', () => window.history.back());
  }, [isLoadingRolesAndPermissions]);

  const clearFilter = () => {
    fetchUSDRequests(null, false, true);
  };

  return (
    <>
      <Header name="Held USD Requests" />

      <div className="customers-page usd-home">
        <div className="customers-page__card">
          {isLoading ? (
            <div className="page-loader">
              <Loader color="#0F60D6" />
            </div>
          ) : (
            <>
              <div className="customers-filter">
                <div className="input-field" onClick={() => setSearchModal(true)}>
                  <input type="text" placeholder="Search requests by user ID" value={usdRequestsParams.userId} />
                </div>
                <div className="query-filter" onClick={() => setFilterModal(true)}>
                  <div>
                    <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                        stroke="#1E293B"
                        strokeWidth="1.5"
                        strokeLinecap="square"
                      />
                    </svg>
                  </div>
                  <div>Filter</div>
                </div>

                {(canResetSearch || canResetFilter) && (
                  <div className="query-filter" onClick={() => clearFilter()}>
                    <div></div>
                    <div>Reset</div>
                  </div>
                )}
              </div>
              {usdRequestsData.documents && usdRequestsData.documents.length === 0 ? (
                <NoData
                  message={canResetFilter || canResetSearch ? 'No USD requests found' : 'No USD requests at the moment'}
                />
              ) : (
                <div>
                  <div className="metric-cards-container">
                    <div className="metric-card">
                      <div className="card-icon">
                        <img src={ReceiptIcon} alt="warning" />
                      </div>
                      <p className="card-title">TOTAL USD REQUEST</p>
                      {isLoadingMetrics && !usdRequestsMetricsData?.totalHeld ? (
                        <Skeleton baseColor="#F6F9FB" highlightColor="#e8e8e8" width={70} height={40} />
                      ) : (
                        <h1 className="amount">{usdRequestsMetricsData?.totalHeld || 0}</h1>
                      )}
                    </div>
                    <div className="metric-card">
                      <div className="card-icon">
                        <img src={CheckListIcon} alt="warning" />
                      </div>
                      <p className="card-title"> RELEASED USD REQUEST</p>
                      {isLoadingMetrics && !usdRequestsMetricsData?.released ? (
                        <Skeleton baseColor="#F6F9FB" highlightColor="#e8e8e8" width={70} height={40} />
                      ) : (
                        <h1 className="amount">{usdRequestsMetricsData?.released || 0}</h1>
                      )}
                    </div>
                    <div className="metric-card">
                      <div className="card-icon">
                        <img src={WarningIcon} alt="warning" />
                      </div>
                      <p className="card-title">REJECTED USD REQUEST</p>
                      {isLoadingMetrics && !usdRequestsMetricsData?.rejected ? (
                        <Skeleton baseColor="#F6F9FB" highlightColor="#e8e8e8" width={70} height={40} />
                      ) : (
                        <h1 className="amount">{usdRequestsMetricsData?.rejected || 0}</h1>
                      )}
                    </div>
                  </div>
                  <USDRequestWithheldTable
                    tableData={usdRequestsData.documents}
                    refetch={() => fetchUSDRequests()}
                    isCustomers={true}
                    isTest={isTest}
                    withheld
                  />
                </div>
              )}
              {!isLoading &&
                usdRequestsData.documents.length < (usdRequestsData?.total || 0) &&
                !usdRequestsParams.search && (
                  <div className="load-more" onClick={() => fetchUSDRequests(null, true)}>
                    {isLoadingMore ? (
                      <Loader color="#0F60D6" maxWidth="50px" />
                    ) : (
                      <span className="pointer">Show more</span>
                    )}
                  </div>
                )}
            </>
          )}

          <ModalSearch
            modalIsOpen={searchModal}
            searchContext="search-usd-requests-held"
            data={usdRequestsParams}
            setIsOpen={setSearchModal}
            searchDataBy={(filter, empty) => {
              const params = {
                ...usdRequestsParams,
                startDate: '',
                endDate: '',
                status: '',
                ...filter.usdrequestsHeld,
              };
              setUsdRequestsParams(params);
              if (!empty) {
                fetchUSDRequests({ ...params, cursor: '' });
              }
            }}
          />

          <ModalFilter
            modalIsOpen={filterModal}
            searchContext="filter-usd-requests-held"
            data={usdRequestsParams}
            setIsOpen={setFilterModal}
            filterDataBy={(filter, empty) => {
              const params = {
                ...usdRequestsParams,
                query: '',
                ...filter.usdrequestsHeld,
              };
              setUsdRequestsParams(params);
              if (!empty) {
                fetchUSDRequests({ ...params, cursor: '' });
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default USDWithHeldRequest;
